module.exports = __webpack_public_path__ + "img/title-bg.dd2bbf8c.png";